/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  list: [],
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
  },
  selecting: {},
  filters: {
    id: [],
    status: [1, 2],
  },
};
